import React from 'react';
import Box from '@rsos/components/capstone/base/Box';
import { VOIP, LANDLINE } from '@rsos/constants/locationTypes';
import { EstimatedAddress } from './styles/common.styles';

const EstimatedAddressLabel = ({
  isMostRecent,
  singleHistoricLocation,
  classOfService,
  classOfServiceCategory,
  rgAddressProvider,
}) => {
  return (
    <Box m={singleHistoricLocation ? '0 16px' : 2} horizontal>
      <EstimatedAddress isMostRecent data-name="estimated-address">
        {classOfServiceCategory === VOIP
          ? `• Provided Address from ANI/ALI (${classOfService})`
          : classOfServiceCategory === LANDLINE
            ? '• Landline Address'
            : isMostRecent
              ? null
              : `Estimated Address ${
                  rgAddressProvider ? `from ${rgAddressProvider}` : ''
                } | VERIFY with caller`}
      </EstimatedAddress>
    </Box>
  );
};

export default EstimatedAddressLabel;
